import React from 'react';
import { Layers } from 'lucide-react';
import {
  HomeIcon,
  ImageIcon,
  VideoIcon,
  BatchIcon,
  TrendForgeIcon,
  MoodboardIcon,
  BrandbookIcon,
  PackageIcon,
  GalleryIcon,
  SendIcon,
} from '../icons/Icons';
import type { MarketingIconName } from './navigation';

// Parte dos ícones não aceita className; o tamanho vem do wrapper ([&_svg]).
const ICONS: Record<MarketingIconName, React.ComponentType> = {
  home: HomeIcon,
  image: ImageIcon,
  video: VideoIcon,
  batch: BatchIcon,
  competitors: TrendForgeIcon,
  references: MoodboardIcon,
  dna: BrandbookIcon,
  products: PackageIcon,
  ads: Layers,
  projects: GalleryIcon,
  publishing: SendIcon,
};

const MarketingNavIcon: React.FC<{ name: MarketingIconName; className?: string }> = ({ name, className = '' }) => {
  const Icon = ICONS[name];
  return (
    <span aria-hidden className={`inline-grid place-items-center w-[18px] h-[18px] [&_svg]:w-[18px] [&_svg]:h-[18px] ${className}`}>
      <Icon />
    </span>
  );
};

export default MarketingNavIcon;
